import { Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutInvoiceProcessingProfileLookup } from "./autogen/AutogenLayoutInvoiceProcessingProfileLookup";

export class InvoiceProcessingProfileLookup extends AutogenLayoutInvoiceProcessingProfileLookup {
    tableLookupOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const label = tableRow.findComponentById("labelTitle") as Label;
        label.text = tableRow.data?.get("title", tableRow.data?.get("id"));
    }
}